import React, { useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";

export default function Login() {
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  // Modal State
  const [modal, setModal] = useState({
    show: false,
    isSuccess: false,
    message: "",
    redirect: null,
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post("https://swiftexprofit.com/login", {
        email,
        password,
      });

      if (res.data?.token) {
        localStorage.setItem("token", res.data.token);
      }

      setModal({
        show: true,
        isSuccess: true,
        message: res.data?.message || "Welcome back! Login successful.",
        redirect: "/",
      });
    } catch (error) {
      setModal({
        show: true,
        isSuccess: false,
        message: error.response?.data?.message || "Invalid credentials. Please try again.",
        redirect: null,
      });
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    const shouldRedirect = modal.redirect;
    setModal({ ...modal, show: false });

    if (shouldRedirect) {
      history.push(shouldRedirect);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100"
      style={{
        backgroundColor: "#0b0e11",
        backgroundImage: "radial-gradient(circle at 50% 0%, rgba(38, 161, 123, 0.15) 0%, transparent 70%)",
        color: "#e0e6ed",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        padding: "20px",
      }}
    >
      {/* MODERN GLASS MODAL */}
      {modal.show && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "16px",
          }}
        >
          <div
            style={{
              backgroundColor: "#181a20",
              border: `1px solid ${modal.isSuccess ? "#26a17b" : "#f6465d"}`,
              borderRadius: "16px",
              padding: "32px 24px",
              width: "100%",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
              animation: "fadeIn 0.2s ease-out",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                backgroundColor: modal.isSuccess ? "rgba(38, 161, 123, 0.15)" : "rgba(246, 70, 93, 0.15)",
                color: modal.isSuccess ? "#26a17b" : "#f6465d",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: "24px",
              }}
            >
              {modal.isSuccess ? "✓" : "✕"}
            </div>

            <h4 style={{ color: "#fff", fontWeight: "600", marginBottom: "8px" }}>
              {modal.isSuccess ? "Success" : "Authentication Failed"}
            </h4>
            <p style={{ color: "#848e9c", fontSize: "14px", marginBottom: "24px", lineHeight: "1.5" }}>
              {modal.message}
            </p>

            <button
              onClick={closeModal}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: modal.isSuccess ? "#26a17b" : "#f6465d",
                color: "#ffffff",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                transition: "opacity 0.2s",
              }}
            >
              {modal.isSuccess ? "Continue to Dashboard" : "Try Again"}
            </button>
          </div>
        </div>
      )}

      {/* MAIN LOGIN CARD */}
      <div
        style={{
          width: "100%",
          maxWidth: "440px",
          backgroundColor: "#181a20",
          border: "1px solid #2b313a",
          borderRadius: "16px",
          padding: "40px 32px",
          boxShadow: "0 16px 32px rgba(0, 0, 0, 0.4)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <h2 style={{ color: "#ffffff", fontWeight: "700", fontSize: "28px", letterSpacing: "-0.5px" }}>
            Sign In
          </h2>
          <p style={{ color: "#848e9c", fontSize: "14px", marginTop: "6px" }}>
            Access your SwiftEx account and assets
          </p>
        </div>

        <form onSubmit={handleLogin}>
          {/* EMAIL INPUT */}
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", color: "#b7bdc6", fontSize: "13px", marginBottom: "6px", fontWeight: "500" }}>
              Email Address
            </label>
            <input
              type="email"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px 16px",
                backgroundColor: "#0b0e11",
                border: "1px solid #2b313a",
                borderRadius: "8px",
                color: "#ffffff",
                fontSize: "14px",
                outline: "none",
                transition: "border-color 0.2s",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#10b981")}
              onBlur={(e) => (e.target.style.borderColor = "#2b313a")}
            />
          </div>

          {/* PASSWORD INPUT */}
          <div style={{ marginBottom: "16px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
              <label style={{ color: "#b7bdc6", fontSize: "13px", fontWeight: "500", margin: 0 }}>
                Password
              </label>
              <Link
                to="/reset"
                style={{ color: "#10b981", fontSize: "13px", textDecoration: "none", fontWeight: "500" }}
              >
                Forgot password?
              </Link>
            </div>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: "12px 42px 12px 16px",
                  backgroundColor: "#0b0e11",
                  border: "1px solid #2b313a",
                  borderRadius: "8px",
                  color: "#ffffff",
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                onBlur={(e) => (e.target.style.borderColor = "#2b313a")}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  color: "#848e9c",
                  fontSize: "12px",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* REMEMBER ME */}
          <div style={{ display: "flex", alignItems: "center", marginBottom: "24px", cursor: "pointer" }}>
            <input
              type="checkbox"
              id="rememberMe"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              style={{
                accentColor: "#10b981",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                marginRight: "8px",
              }}
            />
            <label htmlFor="rememberMe" style={{ color: "#848e9c", fontSize: "13px", cursor: "pointer", margin: 0 }}>
              Remember this device
            </label>
          </div>

          {/* SUBMIT BUTTON */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#10b981",
              color: "#0e1114",
              fontWeight: "600",
              fontSize: "15px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
              transition: "background-color 0.2s, opacity 0.2s",
            }}
          >
            {loading ? "Signing In..." : "Log In"}
          </button>
        </form>

        {/* SIGN UP FOOTER */}
        <div style={{ textAlign: "center", marginTop: "28px", fontSize: "14px", color: "#848e9c" }}>
          Don't have an account?{" "}
          <Link to="/signup" style={{ color: "#10b981", fontWeight: "600", textDecoration: "none" }}>
            Register now
          </Link>
        </div>
      </div>
    </div>
  );
}